import { storeApi, StoreApi } from './store';

export { storeApi, StoreApi };



// WEBPACK FOOTER //
// ./src/api/store/index.ts